// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// Firebase configuration
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCLNDiRr6Egl3Jq-DlF0O-4AM4VI5-mBpk",
  authDomain: "atlantic-primary-care.firebaseapp.com",
  projectId: "atlantic-primary-care",
  storageBucket: "atlantic-primary-care.firebasestorage.app",
  messagingSenderId: "902197703848",
  appId: "1:902197703848:web:a93ea99c337a7abbcd3e9d",
  measurementId: "G-VWNKR44PP3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics }; 